import { GridColDef } from "@mui/x-data-grid";

export interface ConceptsDeductionsRow {
  id: number;
  rowId: string;
  codigoIdentificador: string;
  codigoConcepto: string;
  concepto: string;
  nitAcreedor: string;
  acreedor: string;
  valor: number;
  signo: string;
  codigoCentroCostos: string;
  nombreCentroCostos: string;
  certificadoPresupuestal: string;
  rcp: string;
  codigoMaterial: string;
}

export const columnsConceptsDeductions: GridColDef[] = [
  {
    field: "codigoIdentificador",
    headerName: "Código identificador",
    width: 150,
    flex: 1,
  },
  {
    field: "codigoConcepto",
    headerName: "Código concepto",
    width: 130,
    flex: 1,
  },
  {
    field: "concepto",
    headerName: "Concepto",
    width: 200,
    flex: 1,
  },
  {
    field: "nitAcreedor",
    headerName: "NIT acreedor",
    width: 130,
    flex: 1,
  },
  {
    field: "acreedor",
    headerName: "Acreedor",
    width: 200,
    flex: 1,
  },
  {
    field: "valor",
    headerName: "Valor",
    width: 120,
    flex: 1,
  },
  {
    field: "signo",
    headerName: "Signo",
    width: 80,
    flex: 1,
  },
  {
    field: "codigoCentroCostos",
    headerName: "Código centro costos",
    width: 150,
    flex: 1,
  },
  {
    field: "nombreCentroCostos",
    headerName: "Nombre centro costos",
    width: 200,
    flex: 1,
  },
  {
    field: "certificadoPresupuestal",
    headerName: "CDP",
    width: 180,
    flex: 1,
  },
  {
    field: "rcp",
    headerName: "RPC",
    width: 180,
    flex: 1,
  },
  {
    field: "codigoMaterial",
    headerName: "Código material",
    width: 130,
    flex: 1,
  },
];
